import React from 'react';
import './App.css';

function App() {
  return (
    <div className="app">
      <div className='left'>left</div>
      <div className='right'>right</div>
    </div>
  );
}

export default App;
